import { CalendarDays, Lock } from "lucide-react";
import { PageMasthead } from "@/components/ui-custom/PageMasthead";
import { RevealStagger, staggerItem } from "@/components/ui-custom/RevealOnScroll";
import { motion } from "framer-motion";

const PROGRAMS = [
  { title: "Mesyuarat Agung Tahunan PPPS 2026", date: "15 Mac 2026", desc: "Perhimpunan tahunan rasmi seluruh ahli PPPS di Kuching." },
  { title: "Taklimat Pematuhan & Kesedaran Risiko", date: "22 April 2026", desc: "Sesi taklimat khusus mengenai keperluan pematuhan dan pengurusan risiko terkini untuk ahli." },
  { title: "Sesi Latihan Pengiring Rapat & Kesiapsiagaan", date: "10 Jun 2026", desc: "Latihan lanjutan pengawal peribadi dan kesiapsiagaan bagi ahli PPPS di seluruh Sarawak." },
];

const GALLERY = [
  { src: "/gallery/latihan-berkumpulan.jpg", caption: "Latihan Berkumpulan Pengiring Rapat" },
  { src: "/gallery/latihan-fizikal.jpg", caption: "Latihan Kecergasan Fizikal & Kesiapsiagaan" },
  { src: "/gallery/latihan-lapangan.jpg", caption: "Latihan Lapangan Pengawal Peribadi" },
  { src: "/gallery/taklimat.jpg", caption: "Taklimat & Sesi Perkongsian Ilmu" },
  { src: "/gallery/pencapaian.jpg", caption: "Pengiktirafan & Pencapaian Latihan" },
];

export default function Program() {
  return (
    <div data-testid="program-page">
      <PageMasthead breadcrumb="PROGRAM" title="Program PPPS" subtitle="Aktiviti, latihan dan mesyuarat rasmi persatuan." />

      <section className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-16 space-y-5">
        <RevealStagger staggerDelay={0.08} className="space-y-5">
        {PROGRAMS.map((p) => (
          <motion.div variants={staggerItem} key={p.title} className="flex gap-5 p-6 rounded-xl bg-white border border-piks-border hover:border-piks-gold/40 transition-colors" data-testid={`program-card-${p.title.slice(0, 10)}`}>
            <div className="w-12 h-12 rounded-lg bg-piks-black flex items-center justify-center shrink-0">
              <CalendarDays className="w-5 h-5 text-piks-gold" />
            </div>
            <div>
              <p className="text-xs font-semibold text-piks-red mb-1">{p.date}</p>
              <h3 className="font-semibold text-piks-black mb-1">{p.title}</h3>
              <p className="text-sm text-piks-muted leading-relaxed">{p.desc}</p>
            </div>
          </motion.div>
        ))}
        </RevealStagger>

        <div className="flex items-center gap-3 p-5 rounded-xl bg-piks-ivory border border-dashed border-piks-border text-piks-muted mt-8" data-testid="program-future-latihan">
          <Lock className="w-4 h-4" />
          <p className="text-sm">Modul Latihan &amp; Pensijilan berdaftar — Akan Datang</p>
        </div>
      </section>

      <section className="bg-piks-ivory border-t border-piks-border">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-piks-red mb-3">Galeri</p>
          <h2 className="font-display text-2xl font-bold text-piks-black mb-8">Aktiviti & Latihan PPPS</h2>
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-4" data-testid="program-gallery">
            {GALLERY.map((g, i) => (
              <div
                key={g.src}
                className={`relative rounded-xl overflow-hidden border border-piks-border group ${i === 0 ? "col-span-2 row-span-2" : ""}`}
                data-testid={`gallery-item-${i}`}
              >
                <img src={g.src} alt={g.caption} className="w-full h-full object-cover aspect-square group-hover:scale-105 transition-transform duration-500" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/0 to-transparent opacity-0 group-hover:opacity-100 transition-opacity flex items-end p-3">
                  <p className="text-white text-xs font-medium leading-snug">{g.caption}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
